
export function preloadImage(src: string) {
  return new Promise<void>((resolve, reject) => {
      let img = new Image();
      img.onload = () => { resolve();}
      img.onerror = () => { reject();}
      img.src = src;
  });
}
